const navLinks = [
  {
    id: 1,
    title: 'Getting started',
    anchor: 'overview',
  },
  {
    id: 2,
    title: 'Pillars of Energy Excellence',
    anchor: 'pillars',
  },
  {
    id: 3,
    title: 'Use cases',
    anchor: 'use-cases',
  },
  {
    id: 5,
    title: 'Let’s talk',
    anchor: 'contact-us',
  },
];

export default navLinks;
